<template>
    <switch-theme-message />
    <LaPageHeader heading="">
        <template #controls v-if="websites?.length">
            <LaWebsitePicker v-model="selectedWebsite" :websites="websites" />
        </template>
    </LaPageHeader>
    <LaCardLoader v-if="loading" />
    <LaNoData
        v-else-if="websites && !websites.length"
        header="Add website"
        description="Please add website to show install steps for it."
    >
        <LaAddWebsite />
    </LaNoData>
    <ads-txt-validator v-else-if="selectedWebsite" :website="selectedWebsite"></ads-txt-validator>
</template>
<script>
import LaPageHeader from "@/components/PageHeader";
import LaAddWebsite from "@/components/button/AddWebsite";
import LaWebsitePicker from "@/components/filters/WebsitePicker";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import store from "@/store/store";
import { actionTypes as websiteActionTypes, getterTypes as websiteGetterTypes } from "@/store/Websites/types";
import { getterTypes as publisherGetterTypes } from "@/store/Publisher/types";
import LaNoData from "@/components/NoData";
import LaCardLoader from "@/components/loaders/CardLoader";
import SwitchThemeMessage from "@/components/SwitchThemeMessage.vue";
import AdsTxtValidator from "@/components/adstxt/AdsTxtValidator";
export default {
    name: "LaInstallView",
    components: {
        LaWebsitePicker,
        LaPageHeader,
        LaAddWebsite,
        LaNoData,
        LaCardLoader,
        SwitchThemeMessage,
        AdsTxtValidator,
    },
    data() {
        return {
            paramWebsite: this.$route.params.website ? this.$route.params.website : null,
        };
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const websites = computed(() => store.getters[websiteGetterTypes.getWebsitesByPublisher]);
        const selectedPublisher = computed(() => store.getters[publisherGetterTypes.getSelectedPublisher]);
        const defaultSelected = computed(() => {
            if (!websites.value || !websites.value.length) return null;
            const actualWebsites = websites.value.filter((w) => w.id !== "all");
            const paramWebsite = route.params.website;
            if (paramWebsite) {
                return actualWebsites.find((item) => item.aab_site_id == paramWebsite) || null;
            }
            return actualWebsites[0] || null;
        });
        const selectedWebsite = ref(defaultSelected.value);
        const loading = computed(() => store.getters[websiteGetterTypes.isLoading]);

        // Refetch websites when the selected publisher changes (ltba or yield).
        // Mirrors the FeeView pattern: the view is publisher-aware via the universal
        // getSelectedPublisher getter, no URL param involved.
        watch(
            () => selectedPublisher.value?.id,
            (publisherId) => {
                if (!publisherId) return;
                store.dispatch(websiteActionTypes.getDataByPublisher, { publisherId }).then(() => {
                    selectedWebsite.value = defaultSelected.value;
                });
            },
            { immediate: true }
        );

        watch(
            [selectedWebsite],
            () => {
                if (selectedWebsite.value) {
                    document.title = "AAB Install | " + selectedWebsite.value.site_name;
                }
                if ((!router.currentRoute.params || !router.currentRoute.params.website) && selectedWebsite.value) {
                    router.push({ params: { website: selectedWebsite.value.aab_site_id } });
                }
            },
            { immediate: true }
        );
        return { loading, websites, selectedWebsite };
    },
};
</script>
